export enum Roles {
    User = 'ROLE_USER',
    Staff = 'ROLE_STAFF',
    Manager = 'ROLE_MANAGER',
    Admin = 'ROLE_ADMIN',
}
